<template>
  <v-card>
    <v-tabs
      v-model="tab"
      :background-color="getThemeColor"
      centered
      dark
      icons-and-text
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">
        Bookings
        <v-icon>mdi-calendar</v-icon>
      </v-tab>

      <v-tab href="#tab-2">
        Hours & Rate
        <v-icon>mdi-table</v-icon>
      </v-tab>

      <v-tab href="#tab-3">
        Bio
        <v-icon>mdi-account-box</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="i in 3" :key="i" :value="'tab-' + i">
        <v-card flat v-if="i == 1">
          <FullCalendar class="mt-4" :staff="selectedTalent" :client="null">{{
            i
          }}</FullCalendar>
        </v-card>
        <v-card flat v-else-if="i == 2">
          <AgencyHoursAndRate :staff="selectedTalent"></AgencyHoursAndRate>
        </v-card>
        <v-card flat v-else-if="i == 3">
          <ClientDetail
            class="mt-10"
            table="staff"
            :client="selectedTalent"
            @data-updated="getNewProfile"
          ></ClientDetail>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import ClientDetail from "@/components/Clients/ClientDetail.vue";
import FullCalendar from "@/components/EventsCalendar/FullCalendar.vue";
import AgencyHoursAndRate from "./AgencyHoursAndRate.vue";

export default {
  computed: mapGetters(["getThemeColor"]),
  props: {
    profile: { default: null },
  },
  components: { ClientDetail, FullCalendar, AgencyHoursAndRate },
  mounted() {
    this.selectedTalent = this.profile;
  },
  watch: {
    profile(newProfile) {
      this.selectedTalent = newProfile;
    },
  },
  data() {
    return {
      selectedTalent: null,
      tab: null,
    };
  },
  methods: {
    getNewProfile(profile) {
      this.selectedTalent = profile;
      this.$emit("talent-updated", profile);
    },
  },
};
</script>
